export const CONFIG = {
  cognito: {
    userPoolId: 'eu-central-1_u9YVpQIcm',
    clientId: '7srdnqu6m5cl46930rhm68la2r',
    identityPoolId: 'eu-central-1:4a5de359-679b-4f63-8bfa-cf9a4f4bafd4',
    region: 'eu-central-1'
  }
};



// WEBPACK FOOTER //
// ./src/app/auth/auth.config.ts